import React from 'react'
import { useNavigate } from 'react-router-dom'
import { VStack, Heading, Text, Button, HStack, Center, Icon } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { FiHome, FiArrowLeft, FiSearch } from 'react-icons/fi'
import DashboardLayout from '@/components/Layout/DashboardLayout'
import { MotionBox } from '@/components/Common/MotionBox'

const MotionVStack = motion(VStack as any)

export default function NotFoundPage() {
  const navigate = useNavigate()

  const handleGoHome = () => {
    navigate('/dashboard')
  }

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleGoToSearch = () => {
    navigate('/search')
  }

  return (
    <DashboardLayout>
      <Center h="full" p={8}>
        <MotionVStack
          spacing={8}
          textAlign="center"
          maxW="lg"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {/* 404 Number */}
          <MotionBox
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <Text
              fontSize="8xl"
              fontWeight="bold"
              color="blue.500"
              lineHeight="1"
              letterSpacing="tight"
            >
              404
            </Text>
          </MotionBox>

          {/* Error Message */}
          <VStack spacing={4}>
            <Heading size="xl" color="gray.700">
              Page Not Found
            </Heading>
            <Text fontSize="lg" color="gray.600" maxW="md">
              The page you're looking for doesn't exist or has been moved. Don't worry, let's get
              you back on track.
            </Text>
          </VStack>

          {/* Action Buttons */}
          <MotionVStack
            spacing={4}
            w="full"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <HStack spacing={4} flexWrap="wrap" justify="center">
              <Button
                // leftIcon={<Icon as={FiHome} />}
                colorScheme="blue"
                size="lg"
                onClick={handleGoHome}
                minW="160px"
              >
                Go Home
              </Button>
              <Button
                // leftIcon={<Icon as={FiArrowLeft} />}
                variant="outline"
                colorScheme="blue"
                size="lg"
                onClick={handleGoBack}
                minW="160px"
              >
                Go Back
              </Button>
            </HStack>
            <Button
              leftIcon={<Icon as={FiSearch} />}
              variant="ghost"
              colorScheme="blue"
              size="md"
              onClick={handleGoToSearch}
            >
              Search Documents
            </Button>
          </MotionVStack>
        </MotionVStack>
      </Center>
    </DashboardLayout>
  )
}
